import { createFileRoute } from '@tanstack/react-router';
import {
  domainTarget,
  legacyDomainSearch,
  redirectToHealthReadiness,
} from '@/components/health-readiness/legacy-redirect';

/**
 * The old Health Check overview (T-0224, T-0242): lands on the Overview tab,
 * or on the Domains tab at the domain a `?domain=` named.
 */
export const Route = createFileRoute('/engagements/$engagementId/health/')({
  validateSearch: legacyDomainSearch,
  beforeLoad: ({ params, search }) => {
    throw redirectToHealthReadiness(params.engagementId, domainTarget(search, { tab: 'overview' }));
  },
});
